<section class="main-container">
  <!-- Stepper -->
  <aside class="side-right">
    <app-stepper [steps]="steps" [currentStep]="currentStep"></app-stepper>
  </aside>

  <!-- Main Content -->
  <div class="center-container">
    <!-- Step 1: Only show when from=settings -->
    <div *ngIf="fromPage === 'settings' && currentStep === 1" >
      <p class="mb-8 text-generic">
        {{ 'CHANGE_PASSWORD.ENTER_CURRENT_PASSWORD' | translate }}
      </p>

      <form [formGroup]="currentPasswordForm" class="space-y-4" (ngSubmit)="handleStep1()">
        <app-password-field
          label="{{ 'CHANGE_PASSWORD.CURRENT_PASSWORD' | translate }}"
          placeholder="{{ 'LOGIN.PLACEHOLDER' | translate }}"
          [control]="currentPasswordFormControl"
        ></app-password-field>

        <app-button
          text="{{ 'LOGIN.CONTINUE' | translate }}"
          type="submit"
          variant="primary"
          size="lg"
          extraClass="mt-8"
          [disabled]="currentPasswordForm.invalid"
        ></app-button>
      </form>
    </div>

    <!-- Step 2 (for settings) or Single-step flow (for others) -->
    <div class="pb-10" *ngIf="(fromPage === 'settings' && currentStep === 2) || fromPage !== 'settings'">
      <p class="mb-8 text-generic">
        {{ 'CHANGE_PASSWORD.ENTER_NEW_PASSWORD' | translate }}
      </p>

      <app-password-change (submitAction)="handleConfirmClick($event)"></app-password-change>
    </div>
  </div>
</section>
